<div id="changeEmail" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

  <dp-intro fxFlex></dp-intro>

  <div id="register-form-wrapper" #contentZone [dpPerfectScrollbar]="config" [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">
    <div id="register-form">
      <div class="logo" fxHide.gt-xs [routerLink]="'/'">
        <img [src]="SvgMap.flowNewSquare" alt="">
      </div>

      <div class="title">Email Change Result</div>
      <div class="sub-title black-medium-text" *ngIf="hasResult">Your email address is changed!</div>
      <div class="sub-title black-medium-text" *ngIf="!hasResult && error">{{error}}</div>
    </div>
  </div>
</div>